import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../utils/redux/store";

export interface SideNavBarState {
  open: boolean;
  width: number;
}

const initialState: SideNavBarState = {
  open: true,
  width: 240,
};

export const sideNavBarSlice = createSlice({
  name: "sideNavBar",
  initialState,
  reducers: {
    setSideNavBarVisibility: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
});

export const { setSideNavBarVisibility: setSideNavBar } =
  sideNavBarSlice.actions;

export const selectSideNavBar = (state: RootState) => state;

export default sideNavBarSlice.reducer;
